/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".youtube-video[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;position:absolute;width:100%;height:100%;padding:100px 16px 200px}\n/*# sourceMappingURL=captainAppDownloadDemo-webview.component.css.map*/"];
export { styles as styles };
